export { ProtectedRoute } from './ProtectedRoute/ProtectedRoute';
export { MoviesList } from './MoviesList/MoviesList';
